import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import * as $ from 'jquery';

import GlassForm from './eyeglass/GlassForm';
import LabOrderButton from './eyeglass/labOrder/LabOrderButton';
import LabOrderModal from './eyeglass/labOrder/LabOrderModal';
import ImportWrapper from './import/ImportWrapper';
import UseWarrantyModal from './warranty/UseWarrantyModal';
import { orderCloseModal, orderLoad, verifyCatalog } from '../../../../redux/actions/order/orderActions';
import { orderPromotionRemove } from '../../../../redux/actions/order/orderPromotionActions';
import { storeSettingLoad } from '../../../../redux/actions/storeSettings/storeSettingActions';
import DuplicateLensOrGlassButton from '../../buttons/DuplicateLensOrGlassButton';
import PromotionBanner from './promotions/PromotionBanner';
import { Select } from '../../../../itrust_common/components/form';

const ORDER_TYPE_OPTIONS = [
  { label: 'Uncut', value: 'uncut' },
  { label: 'Onshape', value: 'onshape' },
  { label: 'Roughing', value: 'roughing' },
  { label: 'GivenFrame', value: 'givenFrame' },
  { label: 'Tracing', value: 'tracing' },
]

const getOtherDetails = (obj) => {
  if (!obj) return {};
  const raw =
    obj?.order?.other_details ??
    obj?.data?.order?.other_details ??
    obj?.data?.other_details ??
    obj?.other_details;

  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) || {};
    } catch (e) {
      return {};
    }
  }
  return raw && typeof raw === 'object' ? raw : {};
};

class RenderEyeglasses extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPromoRemoved: false,
      isUseWarrantyModalOpen: false,
      useWarrantyId: null,
      vrxLensesMessage: '',
      openTooltipIndex: null,
    };
  }

  componentDidMount() {
    this.handleOutsideClick = () => {
      if (this.state.openTooltipIndex !== null) {
        this.setState({ openTooltipIndex: null });
      }
    };
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    if (this.handleOutsideClick) {
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }

  reloadOrder = () => {
    const { order, pprops } = this.props;
    if (order?.id) pprops.dispatch(orderLoad(order.id, { include: '*' }));
  }

  openUseWarranty = (warrantyId = null) => {
    this.setState({
      isUseWarrantyModalOpen: true,
      useWarrantyId: warrantyId || null,
    });
  }

  closeUseWarranty = () => {
    this.setState({ isUseWarrantyModalOpen: false, useWarrantyId: null });
  }

  componentDidUpdate(prevProps) {
    const currentPromo = this.props.appliedPromotion || this.props.pprops?.appliedPromotion;
    const prevPromo = prevProps.appliedPromotion || prevProps.pprops?.appliedPromotion;
    if (currentPromo && !prevPromo && this.state.isPromoRemoved) {
      this.setState({ isPromoRemoved: false });
    }
  }

  importFinalGlass(member, index, data) {
    const { pprops } = this.props
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][sphere]`, data.od_sphere))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][cylinder]`, data.od_cylinder))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][axis]`, data.od_axis))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][add]`, data.od_add))
    pprops.dispatch(change('orderEyeglassForm', `${member}[od_glass_details][prism]`, data.od_prism))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][sphere]`, data.os_sphere))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][cylinder]`, data.os_cylinder))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][axis]`, data.os_axis))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][add]`, data.os_add))
    pprops.dispatch(change('orderEyeglassForm', `${member}[os_glass_details][prism]`, data.od_prism))
    $(`#examFinalGlass-Modal${index}`).modal('hide')
  }

  handleRemovePromotion = async () => {
    const { pprops, order } = this.props;
    this.setState({ isPromoRemoved: true });
    pprops.dispatch(change('orderEyeglassForm', 'applied_promotion', null));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][overall_cash_discount]', 0));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][overall_percentage_discount]', 0));
    pprops.dispatch(change('orderEyeglassForm', 'eyeglasses_attributes[0][frame_details][promotion]', 'None'));
    if (order && order.orders_promotion && order.orders_promotion.id) {
      const payload = {
        order: {
          orders_promotion_attributes: {
            id: order.orders_promotion.id,
            _destroy: true,
            settings_promotion_id: null,
          },
        },
      };
      await pprops.dispatch(orderPromotionRemove(order.id, payload, { include: '*' }));
      await pprops.dispatch(orderLoad(order.id, { include: '*' }));
    } else {
      pprops.dispatch(change('orderEyeglassForm', 'orders_promotion_attributes', null));
      if (order && order.id) {
        await pprops.dispatch(orderLoad(order.id, { include: '*' }));
      }
    }
  };

  handleVerifyLenses = async () => {
    const { pprops, order } = this.props;
    const eyeglassOrderId = order?.eyeglasses_attributes?.[0]?.id || order?.eyeglasses_attributes?.[0]?.sub_order_id || order?.eyeglasses_attributes?.[0]?.sub_order_id;
    if (eyeglassOrderId) {
      try {
        const actionResult = await pprops.dispatch(verifyCatalog(eyeglassOrderId));
        const resData =
          actionResult?.value?.data ||
          actionResult?.payload?.data ||
          actionResult?.data ||
          actionResult?.value ||
          actionResult?.payload ||
          actionResult;

        const apiOtherDetails = getOtherDetails(resData);
        const isVerified =
          apiOtherDetails?.verify_eyeglass_lenses === true ||
          apiOtherDetails?.verify_eyeglass_lenses === 'true' ||
          resData?.order?.verify_eyeglass_lenses === true ||
          resData?.verify_eyeglass_lenses === true;

        const newVrxMessage =
          apiOtherDetails?.vrx_lenses_message ||
          resData?.order?.vrx_lenses_message ||
          resData?.vrx_lenses_message ||
          '';

        this.setState({
          vrxLensesMessage: isVerified ? '' : newVrxMessage,
          verifyEyeglassLenses: isVerified,
        });

        if (pprops?.dispatch) {
          pprops.dispatch(change('orderEyeglassForm', 'other_details.verify_eyeglass_lenses', isVerified));
          pprops.dispatch(change('orderEyeglassForm', 'other_details.vrx_lenses_message', isVerified ? '' : newVrxMessage));
        }
      } catch (err) {
        // Reducer handles rejected toastr
      }
    }
  };

  render() {
    const { fields, pprops, order, onRemoteSubmit, currentUser, appliedPromotion, storeSetting } = this.props;

    const settingsList = Array.isArray(storeSetting)
      ? storeSetting
      : storeSetting?.store_settings ||
        pprops?.storeSetting?.store_settings ||
        (Array.isArray(pprops?.storeSetting) ? pprops.storeSetting : []);

    const visionRxSetting = settingsList.find(
      item =>
        item.category === 'vision_rx' &&
        item.store_config?.status === 'active'
    );

    const currentPromo = !this.state.isPromoRemoved && (appliedPromotion || pprops.appliedPromotion);
    const isVerifying = this.props.verifyingCatalog || pprops?.verifyingCatalog;

    const latestVerified = this.props.verifiedCatalog || pprops?.verifiedCatalog;
    const verifiedOtherDetails = getOtherDetails(latestVerified);

    const currentOrder = order || pprops?.order;
    const orderOtherDetails = getOtherDetails(currentOrder);

    const globalVrxLensesMessage =
      this.state.vrxLensesMessage ||
      verifiedOtherDetails?.vrx_lenses_message ||
      orderOtherDetails?.vrx_lenses_message ||
      '';

    return (
      <div className="row">
        {currentPromo && (
          <div className="col-12 my-3">
            <PromotionBanner
              promotion={currentPromo}
              onRemove={this.handleRemovePromotion}
            />
          </div>
        )}
        <div className="col-12 mb-7">
          <div className="d-flex justify-content-between align-items-center mt-6">
            <h5>Eyeglass Order</h5>
            <div className="d-flex align-items-center">
              {order.warranty_attributes?.length > 0 && (
                <button
                  type="button"
                  className="btn btn-outline-primary mr-3 d-inline-flex align-items-center"
                  onClick={() => this.openUseWarranty()}
                >
                  <i className="las la-shield-alt mr-2 font-size-18" />
                  Apply Warranty
                </button>
              )}
              {Boolean(visionRxSetting) && (
                <button
                  type="button"
                  className="btn btn-primary mr-5"
                  onClick={this.handleVerifyLenses}
                  disabled={isVerifying}
                >
                  {isVerifying ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
                      Verifying...
                    </>
                  ) : (
                    'Validate VRX Order'
                  )}
                </button>
              )}
              <div className={`d-flex align-items-center ${order.status === 'finalized' && 'disabled'}`}>
                <ImportWrapper order={order} importName="eyeglass" addBtnLabel="Add New From Existing Prescription" importNameTitle="Eyeglass Prescription" />
                <button type="button" className="btn btn-primary ml-5" onClick={() => { fields.push({ current_user_id: currentUser?.id }); setTimeout(() => pprops.submit(), 500) }}>
                  <i className='la la-plus mr-2 font-size-16'></i>
                  Add New
                </button>
              </div>
            </div>
          </div>
        </div>

        <UseWarrantyModal
          isOpen={this.state.isUseWarrantyModalOpen}
          onClose={this.closeUseWarranty}
          onSuccess={this.reloadOrder}
          order={order}
          initialWarrantyId={this.state.useWarrantyId}
        />

        {fields.map((member, index, members) => {
          const eyeglass = members.get(index)
          const warranty = eyeglass?.warranty_attributes
          const memberData = members.get(index) || {};
          let memberOtherDetails = {};
          try {
            memberOtherDetails =
              typeof memberData?.other_details === 'string'
                ? JSON.parse(memberData.other_details)
                : (memberData?.other_details || {});
          } catch (e) {
            memberOtherDetails = memberData?.other_details || {};
          }
        const hasOtherDetails = Object.keys(memberOtherDetails).length > 0;
        const firstEyeglassOtherDetails = order?.eyeglasses_attributes?.find(item => item.other_details)?.other_details || {};




  const vrxLensesMessage =
  memberOtherDetails?.verify_eyeglass_lenses === true
    ? ''
    : (memberOtherDetails?.vrx_lenses_message || '');

const shouldShowVrxError = Boolean(vrxLensesMessage);
          return (
          <div key={index} className="col-12 mb-7">
            <div className="bg-white shadow-sm rounded">
              <div className="row mx-0">
                <div className="col-12 p-5 border-bottom border-bottom-2 border-light">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className={`${order.status === 'finalized' && 'disabled'}`}>
                      Eyeglass Order #{index + 1}
                      {eyeglass.sub_order_id && <span className="ml-3">| Sub ID: {eyeglass.sub_order_id}</span>}
                      {shouldShowVrxError && (
                        <span
                          className="position-relative d-inline-block ml-2 bg-danger-light p-3 py-1 rounded text-danger"
                          style={{ verticalAlign: 'middle',fontSize: '11px', cursor: 'pointer' }}
                        >
                        <span>
                          VRX Error Message
                          </span>

                          <i
                            className={`las la-info-circle font-size-18  ${
                              vrxLensesMessage ? 'text-danger' : 'text-muted'
                            }`}
                            style={{ cursor: 'pointer' }}
                            title={vrxLensesMessage || 'Vision RX Validation Message'}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.setState((prev) => ({
                                openTooltipIndex: prev.openTooltipIndex === index ? null : index,
                              }));
                            }}
                          />

                          {this.state.openTooltipIndex === index && (
                            <div
                              className="shadow-lg rounded bg-white border text-left p-3"
                              style={{
                                position: 'absolute',
                                top: 'calc(100% + 8px)',
                                left: '-12px',
                                zIndex: 1050,
                                minWidth: '280px',
                                maxWidth: '400px',
                                fontSize: '13px',
                                fontWeight: 'normal',
                                color: '#1e293b',
                                whiteSpace: 'normal',
                                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {/* Tooltip pointer triangle */}
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '-6px',
                                  left: '16px',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '6px solid transparent',
                                  borderRight: '6px solid transparent',
                                  borderBottom: '6px solid #cbd5e1',
                                }}
                              />
                              <div
                                style={{
                                  position: 'absolute',
                                  top: '-5px',
                                  left: '16px',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '6px solid transparent',
                                  borderRight: '6px solid transparent',
                                  borderBottom: '6px solid #ffffff',
                                }}
                              />
                              <div className="d-flex align-items-center justify-content-between border-bottom pb-1 mb-2">
                                <span className="font-weight-bold text-dark font-size-12 d-flex align-items-center">
                                  VRX Error Message
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-link p-0 text-muted ml-2"
                                  style={{ fontSize: '16px', lineHeight: 1 }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ openTooltipIndex: null });
                                  }}
                                >
                                  &times;
                                </button>
                              </div>
                              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.45 }}>
                                {vrxLensesMessage || "--"}
                              </div>
                            </div>
                          )}
                        </span>
                      )}
                      {/* {members.get(index).stock_lens_amount_on_hand && <span className="badge badge-info badge-pill ml-3 pointer font-size-14" style={{ height: 22 }} title='Stock Lens Amount in Hand'>
                        {members.get(index).stock_lens_amount_on_hand}
                      </span>} */}
                    </h5>
                    <div className="d-flex align-items-center">
                      {Boolean(visionRxSetting) && (
                      <div className={`${order.status === 'finalized' && 'disabled'} d-flex align-items-center mr-3`} style={{ minWidth: 200 }}>
                        <label className="mb-0 mr-3 text-nowrap">Lens Type</label>
                        <Field
                          name="other_details.lens_type"
                          component={Select}
                          data={ORDER_TYPE_OPTIONS}
                          textField="label"
                          valueField="value"
                          placeholder="Select"
                          className="form-control form-control-sm"
                          wrapperClasses="mb-0 flex-grow-1"
                          onChange={(e, val) => {
                            const value = val !== undefined ? val : (e?.target ? e.target.value : e);
                            pprops.dispatch(change('orderEyeglassForm', 'other_details.lens_type', value));
                            setTimeout(() => pprops.submit(), 500);
                          }}
                        />
                      </div>
                      )}
                      {warranty?.id && (
                        <button
                          type="button"
                          className="btn btn-outline-primary mx-3 d-inline-flex align-items-center"
                          onClick={() => this.openUseWarranty(warranty.id)}
                        >
                          <i className="las la-shield-alt mr-2 font-size-18" />
                          <span>Apply Warranty</span>
                        </button>
                      )}
                      {Boolean(visionRxSetting || vrxLensesMessage || hasOtherDetails) && (
                        <button
                          type="button"
                          className="btn btn-primary mr-5"
                          onClick={this.handleVerifyLenses}
                          disabled={isVerifying}
                        >
                          {isVerifying ? (
                            <>
                              <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />
                              Verifying...
                            </>
                          ) : (
                            'Validate VRX Lenses'
                          )}
                        </button>
                      )}
                      <div className={`${order.status === 'finalized' && 'disabled'}`}>
                        <DuplicateLensOrGlassButton orderId={order.id} lensOrGlassName='eyeglass' id={eyeglass?.id}>
                          <button className={`btn btn-outline-primary mx-3`} aria-disabled="true">Duplicate</button>
                        </DuplicateLensOrGlassButton>
                        {
                          members.get(index).is_on_hold ?
                            <button type="button" className="btn btn-warning mx-3"
                              onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[is_on_hold]`, false)); setTimeout(() => pprops.submit(), 500) }}
                            >
                              Unhold Order
                            </button>
                            :
                            <button type="button" className="btn btn-outline-primary mx-3"
                              onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[is_on_hold]`, true)); setTimeout(() => pprops.submit(), 500) }}
                            >
                              Hold Order
                            </button>
                        }
                        {order.exam_examination_id &&
                          <button onClick={() => $(`#examFinalGlass-Modal${index}`).modal()} type="button" className="btn btn-outline-primary mx-3" >
                            Final Rx
                          </button>
                        }
                      </div>
                      <LabOrderButton resourceId={eyeglass.id} labOrderId={eyeglass.lab_order_id}>
                        <button type="button" className="btn btn-outline-primary mx-3" onClick={()=>onRemoteSubmit('orderEyeglassForm')}>
                          Lab Order
                        </button>
                      </LabOrderButton>
                      <button type="button" className={`${order.status === 'finalized' && 'disabled'} btn btn-outline-danger ml-3`}
                        onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 500) }}>
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
                <div className={`${order.status === 'finalized' && 'disabled'}`}>
                  {eyeglass.id &&
                    <GlassForm
                      key={`glass-id${eyeglass.id}`}
                      {...this.props}
                      currentEyeglass={eyeglass}
                      member={member}
                    />
                  }
                </div>
              </div>
            </div>
            <LabOrderModal resourceId={members.get(index).id} labOrderId={members.get(index)?.lab_order_id} resourceType="Orders::Eyeglass" />
            {this.renderExamLensModal(member, index)}
          </div>
          );
        })}
      </div>
    );
  }

  renderExamLensModal(member, index) {
    const { exam } = this.props
    return (
      <div className="inner-modal">
        <div className="modal fade" id={`examFinalGlass-Modal${index}`} tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog" role="document">
            <div className="modal-content border-0 rounded shadow-lg">
              <div className="modal-header border-bottom border-bottom-2 border-light">
                <h5>Finalized Glass Prescriptions</h5>
                <button type="button" className="btn btn-outline-primary" onClick={() => $(`#examFinalGlass-Modal${index}`).modal('hide')}>
                  Close
                </button>
              </div>
              <div className="modal-body px-0 py-5">
                {
                  exam.id && exam.finalized_glasses_attributes.map((finalizedGlass, index) =>
                    <div className="overview-table mb-7">
                      <table className="table table-hover shadow-none">
                        <thead>
                          <tr className="text-dark border-bottom border-bottom-2 border-light bg-light">
                            <th scope="col">{index + 1}</th>
                            <th scope="col" colSpan="5">Issue Date: {exam.issue_date}</th>
                            <th scope="col">
                              <button className="btn btn-primary px-3 py-2" onClick={() => this.importFinalGlass(member, index, finalizedGlass)}>
                                Import
                              </button>
                            </th>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <th scope="col"></th>
                            <th scope="col">Eye</th>
                            <th scope="col">SPH</th>
                            <th scope="col">CYL</th>
                            <th scope="col">Axis</th>
                            <th scope="col">Add</th>
                            <th scope="col">Prism</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td>OD</td>
                            <td>{finalizedGlass.od_sphere}</td>
                            <td>{finalizedGlass.od_cylinder}</td>
                            <td>{finalizedGlass.od_axis}</td>
                            <td>{finalizedGlass.od_add}</td>
                            <td>{finalizedGlass.od_prism}</td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td>OS</td>
                            <td>{finalizedGlass.os_sphere}</td>
                            <td>{finalizedGlass.os_cylinder}</td>
                            <td>{finalizedGlass.os_axis}</td>
                            <td>{finalizedGlass.os_add}</td>
                            <td>{finalizedGlass.os_prism}</td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td className="font-weight-bold">Recommendations</td>
                            <td colSpan="5">
                              {
                                finalizedGlass.recommendations && Object.keys(finalizedGlass.recommendations).join(", ")
                              }
                            </td>
                          </tr>
                          <tr className="text-dark border-bottom border-bottom-2 border-white bg-light">
                            <td></td>
                            <td className="font-weight-bold">Comments</td>
                            <td colSpan="5">
                              {finalizedGlass.notes}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


class EyeglassForm extends Component {

  componentDidMount() {
    const { order, storeSetting, dispatch } = this.props;
    const storeId = order?.store_id || localStorage.getItem('StoreID');
    const settings = Array.isArray(storeSetting)
      ? storeSetting
      : storeSetting?.store_settings || [];
    if (settings.length === 0 && storeId && dispatch) {
      dispatch(storeSettingLoad({ filter: { store_id: storeId }, page: 1, rpp: 999999999 }));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(orderCloseModal(false))
  }

  render() {
    const { handleSubmit, order, exam, onSubmit, onRemoteSubmit, appliedPromotion , storeSetting } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <FieldArray name="eyeglasses_attributes"
          props={{
            order: order,
            exam: exam,
            onSubmit: onSubmit,
            onRemoteSubmit: onRemoteSubmit,
            currentUser: this.props.currentUser,
            appliedPromotion: appliedPromotion,
            verifyingCatalog: this.props.verifyingCatalog,
            verifiedCatalog: this.props.verifiedCatalog,
            pprops: this.props,
            storeSetting : storeSetting
          }}
          component={RenderEyeglasses} />
      </form>
    )
  }
}


EyeglassForm = reduxForm({
  form: 'orderEyeglassForm',
  enableReinitialize: true,
  onChange: (values, dispatch, props) => {
    if (props.dirty) {
      dispatch(orderCloseModal(true))
    }
  }
})(EyeglassForm)

const selector = formValueSelector('orderEyeglassForm')

EyeglassForm = connect(state => {
  const { order: { order, verifyingCatalog, verifiedCatalog }, exam: { exam }, auth, storeSetting } = state
  const currentEyeglassAttributes = selector(state, 'eyeglasses_attributes')
  const appliedPromotion = selector(state, 'applied_promotion')
  const eyeglassAttrs = currentEyeglassAttributes || order.eyeglasses_attributes || []
  const framePromoName = eyeglassAttrs[0]?.frame_details?.promotion
  const resolvedPromotion =
    appliedPromotion !== undefined
      ? appliedPromotion
      : (order.orders_promotion
        ? {
            name: order.orders_promotion.name || order.orders_promotion.code || 'Promotion',
            code: order.orders_promotion.code,
            savings: order.orders_promotion.savings || 0,
          }
        : framePromoName && framePromoName !== 'None'
        ? {
            name: framePromoName,
            code: '',
            savings: parseFloat(eyeglassAttrs[0]?.overall_cash_discount || 0) || 0,
          }
        : null)

  const storeSettingsList =
    storeSetting?.store_settings ||
    (Array.isArray(storeSetting) ? storeSetting : []);

  let orderOtherDetails = {};
  try {
    orderOtherDetails =
      typeof order?.other_details === 'string'
        ? JSON.parse(order.other_details)
        : (order?.other_details || {});
  } catch (e) {
    orderOtherDetails = order?.other_details || {};
  }

  return {
    exam: exam,
    order: order,
    storeSetting: storeSettingsList,
    verifyingCatalog,
    verifiedCatalog,
    currentUser: auth.user,
    currentEyeglassAttributes,
    appliedPromotion: resolvedPromotion,
    initialValues: {
      id: order.id,
      eyeglasses_attributes: order.eyeglasses_attributes,
      applied_promotion: resolvedPromotion,
      other_details: {
        ...orderOtherDetails
      }
    }
  }
})(EyeglassForm)

export default EyeglassForm;